import React, { Component } from 'react';
import { history } from './history';
import { connect } from 'react-redux';


function mapStateToProps(state) {
    return {
        isLogin: state.auth.logInSuccess,
    }
}

export default function (ProtectedComponent) {
    class Auth extends Component {
        componentWillMount() {
            if(!this.props.isLogin) {
             history.push('/');
            }
            if(localStorage.getItem('user') === undefined) {
                history.push('/')
            }
        }
        componentWillUpdate({isLogin}) {
            if(!isLogin) {
              history.push('/');
            }
        }

        render() {
            return (
                ProtectedComponent ? <ProtectedComponent {...this.props}/> : alert("There is no Async component" )
            )
        }
    }

    return connect(mapStateToProps)(Auth);
}


// WEBPACK FOOTER //
// ./src/helpers/auth.js